import Light from "../../assets/images/landing/underline.png"
const Underline = () => {
    return (
        <div>
            <img className="light" src={Light} />
        </div>
    )
}

export default Underline;